import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import {useDebounce, KTSVG} from '../../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {DeleteData, GetFilterContactSegment} from './SegmentSlice/SegmentSlice'
import CreateSegmentPopup from './Modal/CreateSegmentPopup'
import QuickMessageDrawerInner from '../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import NodataYet from '../../../../Components/NodataYet'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import axios from 'axios'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import AddTagModal from './Modal/AddTag'
import { toast } from 'react-toastify'
import { isNumber } from '../../../../Utils/_helpers/number'
import {useResponsive} from '../../../../hooks/useResponsive'
import {SegmentContactMobileCard} from './SegmentContactMobileCard'
import './ContactListBySegment.scss'

const ContactListBySegment = () => {
  const API_URL = ENV().REACT_APP_API_URL
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const param: any = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {isMobile} = useResponsive()
  const Segmentlist = useSelector((state: any) => state?.SegmentData?.segmaent?.data?.items)
  const subscriberList = useSelector((state: any) => state?.subscriberData?.subscriberList?.data)
  const segmentContact = useSelector((state: any) => state?.SegmentData?.segmentContact?.data)
  const [createSegment, setCreateSegment] = useState(false)
  const [quickMessage, setQuickmessage] = useState(false)
  const [isShowAddTagModal, setIsShowAddTagModal] = useState(false)

  // const subscriberList = useSelector((state: any) => state?.subscriberData?.subscriberList?.data)
  const dbOptions: any[] = useSelector(
    (state: any) => state?.subscriberData?.FieldName?.data?.fields
  )
  //Delete All state
  const [val, setVal] = useState<any>([])
  const [checkList, setCheckList] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })
  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeleteData({
          segmentIds: [param?.state?._id],
        })
      )
      setConfirm(false)
      setCheckList([])
      navigate('/contacts/segments')
    }
  }, [confirm])

  const debouncedSearchTerm = useDebounce(page?.search, 3000)
  useEffect(() => {
    dispatch(startLoadding())
    dispatch(GetFilterContactSegment({id: param?.state?._id, page: page}))
  }, [debouncedSearchTerm, page.page, page.size])
  ///////CUSTOM FUNCTION ///////////////////////////////////////////
  const handleDeleteAll = () => {
    setOpen(true)
    // setDeleteIds({contactIds: checkList , tagId:param.state})
  }

  const handleSingleDelete = (val: any) => {
    setOpen(true)
    setDeleteIds({contact_ids: val?._id, group: val?.group?._id})
  }

  const handleCheckAll = () => {
    if (checkList?.length == segmentContact?.items?.length) {
      setCheckList([])
    } else {
      let list = segmentContact?.items?.map((key: any) => key._id)
      setCheckList([...list])
    }
  }

  const handleCheck = (e: any) => {
    if (checkList?.includes(e.target.value)) {
      checkList.splice(checkList?.indexOf(e.target.value), 1)

      setCheckList([...checkList])
    } else {
      setCheckList([...checkList, e.target.value])
    }
  }

  const checkField = () => {
    let fields = ['First Name', 'Full Name', 'Last Name']
    if (dbOptions?.find((val: any) => fields.includes(val)) == undefined) {
      return false
    } else {
      return true
    }
  }
  const handleExport = (e: any) => {
    axios
      .get(`${API_URL}segment/exportSegmentContacts/${e}`, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res: any) => {
        window.open(`${API_DOMAIN}${res.data.data.downloadurl}`, '_self')
      })
  }
  const handleEdit = () => {}
  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        page={page}
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Confirm to delete'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const sendQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        show={quickMessage}
        handleClose={() => setQuickmessage(false)}
        contacts={segmentContact?.items
          ?.filter((key: any) => checkList?.includes(key?._id))
          ?.map((key: any) => ({value: key?.number, label: key?.number}))}
      />
    ),
    [checkList, quickMessage]
  )
  const createSegmentPopup = useMemo(
    () => (
      <CreateSegmentPopup
        segmentData={val}
        setSegmentData={setVal}
        show={createSegment}
        handleClose={() => setCreateSegment(false)}
      />
    ),
    [createSegment, val]
  )

  const addTagModal = useMemo(
    () => (
      <AddTagModal
        show={isShowAddTagModal}
        handleClose={() => {
          setIsShowAddTagModal(false)
          dispatch(GetFilterContactSegment({id: param?.state?._id, page: page}))
        }}
        segmentId={param?.state?._id || ''}
      />
    ),
    [isShowAddTagModal]
  )

  const isInBuildSegment = Segmentlist?.find((key: any) => key?._id == param?.state?._id)?.isInBuild

  return (
    <>
      {AuthenticateUser('send-quick-sms') && quickMessage && sendQuickMessage}
      {createSegmentPopup}
      {confirmation}
      {addTagModal}
      <div className='card mb-0'>

        <div className={`card-header border-0 pt-12 ${isMobile ? 'px-4' : 'px-9'} ${isMobile ? 'segment-contact-list-header-mobile' : ''}`}>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>
              {segmentContact?.segmentName}

              {(AuthenticateUser('edit-segment') && !isInBuildSegment) && (
                <button
                  onClick={() => {
                    let data = Segmentlist?.find((key: any) => key?._id == param?.state?._id)
                    setVal(data)
                    setCreateSegment(true)
                  }}
                  className='btn btn-sm btn-icon btn-light btn-active-light-primary ms-3 fs-10'
                >
                  <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-6' />
                </button>
              )}
            </span>
          </h3>
          <div className={`d-flex ${isMobile ? 'flex-column gap-3' : ''}`}>
            <div className={`d-flex align-items-center position-relative my-1 ${isMobile ? 'w-100' : 'me-5'}`}>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className={`form-control form-control-solid ${isMobile ? 'w-100' : 'w-250px'} ps-14`}
                placeholder='Search user'
                onChange={(e: any) => setPage({...page, search: e.target.value})}
              />
            </div>
            <div className={isMobile ? 'w-100' : 'me-0'}>
              {(AuthenticateUser('send-quick-sms') ||
                AuthenticateUser('export-segment-based-contacts') ||
                AuthenticateUser('export-segment-based-contacts') ||
                AuthenticateUser('edit-segment') ||
                AuthenticateUser('delete-segment')) && (
                <button
                  className={`btn btn-primary ${isMobile ? 'w-100' : ''}`}
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                >
                  Actions
                  <span className='svg-icon svg-icon-primary svg-icon-2 ms-2 me-0'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24px'
                      height='24px'
                      viewBox='0 0 24 24'
                      version='1.1'
                    >
                      <g stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
                        <polygon points='0 0 24 0 24 24 0 24' />
                        <path
                          d='M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z'
                          fill='#ffffff'
                          fillRule='nonzero'
                          transform='translate(12.000003, 11.999999) rotate(-180.000000) translate(-12.000003, -11.999999)'
                        />
                      </g>
                    </svg>
                  </span>
                </button>
              )}
              <div
                className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3'
                data-kt-menu='true'
                style={{}}
              >
                <div className='menu-item px-3'>
                  {AuthenticateUser('send-quick-sms') && (
                    <div className='aside-footer flex-column-auto ' id='kt_drawer_chat_toggle'>
                      <a
                        target='_blank'
                        className='menu-link px-3'
                        data-bs-toggle='tooltip'
                        data-bs-trigger='hover'
                        data-bs-dismiss-='click'
                        title='Check out the complete documentation with over 100 components'
                        //onClick={()=>dispatch(QuickMsg("profile"))}
                        onClick={() => {
                          if (checkList) {
                            if (checkList?.length > 0) {
                              navigate(`/new-message`, {
                                state: {
                                  selectedType: 'contacts',
                                  data: segmentContact?.items
                                    ?.filter((key: any) => checkList?.includes(key?._id))
                                    ?.map((key: any) => key?.number),
                                },
                              })
                            } else {
                              navigate(`/new-message`, {
                                state: {
                                  selectedType: 'segmentOrTags',
                                  data: `segment_${param?.state?._id}`,
                                },
                              })
                            }
                          }
                        }}
                      >
                        Bulk Message
                      </a>

                      {/* <a href="#" className="menu-link px-3">Send quick message</a> */}
                    </div>
                  )}
                </div>
                <div className='menu-item px-3'>
                  {AuthenticateUser('send-quick-sms') && (
                    <div className='aside-footer flex-column-auto '>
                      <a
                        className='menu-link px-3'
                        title='Check out the complete documentation with over 100 components'
                        onClick={() => setQuickmessage(true)}
                      >
                        Send quick message
                      </a>
                      {/* <a href="#" className="menu-link px-3">Send quick message</a> */}
                    </div>
                  )}
                </div>

                {checkList && checkList.length === 0 && (
                  <div className='menu-item px-3'>
                    <div className='aside-footer flex-column-auto '>
                      <a
                        className='menu-link px-3'
                        title='Check out the complete documentation with over 100 components'
                        onClick={() => setIsShowAddTagModal(true)}
                      >
                        Add Tag
                      </a>
                    </div>
                  </div>
                )}

                <div className='menu-item px-3'>
                  {AuthenticateUser('export-segment-based-contacts') && (
                    <div className='aside-footer flex-column-auto '>
                      <a
                        className='menu-link px-3'
                        title='Check out the complete documentation with over 100 components'
                        onClick={() => handleExport(param?.state?._id)}
                      >
                        Export as CSV
                      </a>
                      {/* <a href="#" className="menu-link px-3">Send quick message</a> */}
                    </div>
                  )}
                </div>

                <div className='menu-item px-3'>
                  <span
                    className='menu-link px-3'
                    onClick={() => {
                      navigator.clipboard.writeText(param?.state?._id)
                      toast.success('Successfully copied segment id')
                    }}
                    data-kt-users-table-filter='copy_row'
                  >
                    Copy ID
                  </span>
                </div>

                {(AuthenticateUser('edit-segment') && !isInBuildSegment) && (
                  <div
                    className='menu-item px-3 my-1'
                    onClick={() => {
                      let data = Segmentlist?.find((key: any) => key?._id == param?.state?._id)
                      setVal(data)
                      setCreateSegment(true)
                    }}
                  >
                    <a className='menu-link px-3'> Edit rule</a>
                  </div>
                )}
                {(AuthenticateUser('delete-segment') && !isInBuildSegment) &&  (
                  <div className='menu-item px-3 my-1' onClick={handleDeleteAll}>
                    <a className='menu-link px-3 text-danger'>Delete Segment</a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {segmentContact?.items?.length > 0 ? (
          <div className={`card-body pt-5 ${isMobile ? 'px-4' : ''}`}>
            {/* <button className='btn btn-primary ' onClick={handleDeleteAll}>UNASSIGNED TAGS</button> */}
            <div className='tab-content'>
              {isMobile ? (
                /* Mobile view: Card layout */
                <div className='mobile-segment-contacts-list'>
                  {/* Select All Checkbox */}
                  <div className='select-all-section mb-3'>
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={checkList?.length >= segmentContact?.items?.length && segmentContact?.items?.length > 0}
                        onChange={handleCheckAll}
                        id='select-all-mobile'
                      />
                      <label className='form-check-label' htmlFor='select-all-mobile'>
                        Select All
                      </label>
                    </div>
                  </div>
                  {segmentContact?.items?.map((val: any) => (
                    <SegmentContactMobileCard
                      key={val._id}
                      contact={val}
                      isSelected={checkList?.includes(val._id)}
                      onSelect={(id) => {
                        if (checkList?.includes(id)) {
                          setCheckList(checkList.filter((item: string) => item !== id))
                        } else {
                          setCheckList([...checkList, id])
                        }
                      }}
                      dbOptions={dbOptions}
                    />
                  ))}
                </div>
              ) : (
                /* Desktop view: Table layout */
                <div className='table-responsive'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bold text-muted text-uppercase'>
                        <th className='w-25px'>
                          <div className='form-check form-check-sm form-check-custom form-check-solid'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              value='ALL'
                              data-kt-check='true'
                              data-kt-check-target='.widget-9-check'
                              checked={checkList?.length >= segmentContact?.items?.length}
                              onChange={handleCheckAll}
                            />
                          </div>
                        </th>
                        <td>{isNumber(val?.number) ? '-' : val?.number}</td>
                        <th>Tags</th>

                        {checkField() && dbOptions?.includes('First Name') && <th>First Name</th>}
                        {checkField() && dbOptions?.includes('Last Name') && <th>Last Name</th>}
                        {checkField() && dbOptions?.includes('Full Name') && <th>Full Name</th>}
                        {dbOptions?.map((val: any, i: number) => {
                          if (!['First Name', 'Full Name', 'Last Name']?.includes(val)) {
                            return <th key={i}>{val}</th>
                          }
                        })}

                        <th>Date Added</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody className='text-gray-600'>
                      {segmentContact?.items?.map((val: any) => (
                        <tr key={val._id}>
                          <td>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input widget-9-check'
                                type='checkbox'
                                value={val?._id}
                                checked={checkList?.includes(val?._id)}
                                onChange={handleCheck}
                              />
                            </div>
                          </td>
                          <td>{val?.number}</td>

                          <td
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            title={val?.tags
                              ?.filter((data: any) => {
                                if (data?.type) {
                                  return data?.isHidden !== false && data?.type !== 'list'
                                }
                                return data?.isHidden !== false
                              })
                              ?.map((data: any) => data?.name)
                              .join()}
                          >
                            <div className='d-flex gap-2 align-items-center flex-wrap '>
                              {val?.tags
                                ?.filter((data: any) => {
                                  if (data?.type) {
                                    return data?.isHidden !== false && data?.type !== 'list'
                                  }
                                  return data?.isHidden !== false
                                })
                                ?.map(
                                  (data: {_id: string; name: string; color: string}, i: number) => (
                                    <div
                                      key={i}
                                      className='inbox-tags'
                                      style={{
                                        color: data?.color ? 'white' : 'black',
                                        backgroundColor: data?.color ? data?.color : '',
                                      }}
                                    >
                                      {data?.name}
                                    </div>
                                  )
                                )}
                            </div>
                          </td>

                          {dbOptions?.includes('First Name') &&
                            (val?.fields?.findIndex((val: any) => val?.name === 'First Name') !==
                            -1 ? (
                              <td>
                                {
                                  val?.fields?.[
                                    val?.fields?.findIndex((val: any) => val?.name === 'First Name')
                                  ]?.value
                                }
                              </td>
                            ) : (
                              <td>-</td>
                            ))}
                          {dbOptions?.includes('Last Name') &&
                            (val?.fields?.findIndex((val: any) => val?.name === 'Last Name') !==
                            -1 ? (
                              <td>
                                {
                                  val?.fields?.[
                                    val?.fields?.findIndex((val: any) => val?.name === 'Last Name')
                                  ]?.value
                                }
                              </td>
                            ) : (
                              <td>-</td>
                            ))}
                          {dbOptions?.includes('Full Name') &&
                            (val?.fields?.findIndex((val: any) => val?.name === 'Full Name') !==
                            -1 ? (
                              <td>
                                {
                                  val?.fields?.[
                                    val?.fields?.findIndex((val: any) => val?.name === 'Full Name')
                                  ]?.value
                                }
                              </td>
                            ) : (
                              <td>-</td>
                            ))}
                          {dbOptions?.map((Fields: any, i: number) => {
                            let check = val?.fields?.map((key: any) => key?.name)
                            if (!['First Name', 'Full Name', 'Last Name']?.includes(Fields)) {
                              if (check?.includes(Fields)) {
                                if (['Birthday'].includes(Fields)) {
                                  return (
                                    <td key={i}>
                                      {moment(
                                        val?.fields.find((key: any) => key?.name == Fields)?.value
                                      ).format('DD/MM/YYYY')}
                                    </td>
                                  )
                                }

                                return (
                                  <td key={i}>
                                    {val?.fields?.find((key: any) => key?.name == Fields)?.value}
                                  </td>
                                )
                              } else {
                                return <td key={i}>--</td>
                              }
                            }
                          })}

                          <td>{moment(val?.createdAt).format('DD/MM/YYYY')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className={`abcd ${isMobile ? 'px-0' : ''}`}>
                <select onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})} value={page.size}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={250}>250</option>
                </select>
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={segmentContact?.totalPages}
                  onPageChange={(e: any) => setPage({...page, page: e.selected + 1})}
                  containerClassName={'pagiantion'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          </div>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default ContactListBySegment
